import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, CheckCircle2, AlertCircle, ArrowLeft } from 'lucide-react';
import api from '../lib/api';

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const token = new URLSearchParams(window.location.search).get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Wachtwoord moet minimaal 8 tekens zijn'); return; }
    if (password !== confirm) { setError('Wachtwoorden komen niet overeen'); return; }
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, new_password: password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Er is een fout opgetreden. Probeer het opnieuw.');
    } finally { setLoading(false); }
  };

  const goToLogin = () => { window.location.href = '/'; };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f0f2f5] to-[#e4e8f0] p-4" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-[#003366] p-6 text-center">
            <h1 className="text-xl font-bold text-white">TW1 Admin Portaal</h1>
            <p className="text-[#f5a800] text-sm mt-1">Wachtwoord resetten</p>
          </div>

          <div className="p-6">
            {success ? (
              <div className="text-center space-y-4" data-testid="reset-success">
                <CheckCircle2 className="w-12 h-12 text-[#1e8c45] mx-auto" />
                <h2 className="text-lg font-semibold text-[#0b1220]">Wachtwoord gewijzigd!</h2>
                <p className="text-sm text-[#526071]">Je kunt nu inloggen met je nieuwe wachtwoord.</p>
                <Button onClick={goToLogin} className="bg-[#003366] hover:bg-[#00244d] w-full" data-testid="go-to-login-btn">
                  <ArrowLeft className="w-4 h-4 mr-2" /> Naar inlogpagina
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-1">
                  <Label className="text-xs text-[#526071]">Nieuw wachtwoord</Label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <Input
                      type="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      placeholder="Minimaal 8 tekens"
                      className="pl-10"
                      required
                      data-testid="new-password-input"
                    />
                  </div>
                </div>
                <div className="space-y-1">
                  <Label className="text-xs text-[#526071]">Bevestig wachtwoord</Label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <Input
                      type="password"
                      value={confirm}
                      onChange={e => setConfirm(e.target.value)}
                      placeholder="Herhaal wachtwoord"
                      className="pl-10"
                      required
                      data-testid="confirm-password-input"
                    />
                  </div>
                </div>
                {error && (
                  <div className="flex items-center gap-2 p-3 rounded-lg bg-red-50 border border-red-200" data-testid="reset-error">
                    <AlertCircle className="w-4 h-4 text-[#c0392b] flex-shrink-0" />
                    <p className="text-sm text-[#c0392b]">{error}</p>
                  </div>
                )}
                <Button type="submit" disabled={loading} className="w-full bg-[#003366] hover:bg-[#00244d]" data-testid="reset-submit-btn">
                  {loading ? 'Bezig...' : 'Wachtwoord resetten'}
                </Button>
                <button type="button" onClick={goToLogin} className="w-full text-xs text-[#003366] hover:underline mt-2">
                  Terug naar inlogpagina
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
